<template>
  <div class="template-form-compact">
    <div class="form-section">
      <h6 class="section-title">Обробляємі сторони</h6>
      <div class="input-grid">
        <div class="input-group">
          <label for="p1">За довжиною</label>
          <select id="p1" :class="{ 'red': detailValidation('P1_') }" v-model.number="detail.p1">
            <option value="0">Не обробляти</option>
            <option value="1">Одна</option>
            <option value="2">Дві</option>
          </select>
          <div v-if="detailValidation('P1_')" class="error-message">
            {{ detailValidationText('P1_') }}
          </div>
        </div>

        <div class="input-group">
          <label for="p2">За шириною</label>
          <select id="p2" :class="{ 'red': detailValidation('P2_') }" v-model.number="detail.p2">
            <option value="0">Не обробляти</option>
            <option value="1">Одна</option>
            <option value="2">Дві</option>
          </select>
          <div v-if="detailValidation('P2_')" class="error-message">
            {{ detailValidationText('P2_') }}
          </div>
        </div>
      </div>
    </div>

    <div class="form-section">
      <div class="input-group">
        <label for="note">Примітка</label>
        <input id="note" v-model="detail.note" placeholder="Введіть примітку..." />
      </div>
    </div>
  </div>
</template>

<script>
import validation from "@/mixins/BaseTemplate"

export default {
  mixins: [validation],
  props: [
    'detail'
  ],
  computed: {
    resp() {
      return this.$store.state.data.response;
    },
  },
  watch: {
    detail: function (newValue, oldValue) {
      this.$root.$emit('update-detail', this.detail);
    }
  },
  name: "Template_7"
}
</script>


<style scoped>
/* All styles moved to src/assets/scss/general/templates.scss */
</style>